import { gql } from "@apollo/client";

/**
 * Product Attributes
 */
export const GET_PRODUCT_ATTRIBUTES = gql`
  query GetProductAttributes {
    productAttributes(sort: [{ field: "name", direction: ASC }]) {
      count
      data {
        id
        name
        level
        description
        childrenAttributes {
          id
          name
          level
          description
        }
      }
    }
  }
`;

export const ATTRIBUTE_PRODUCT_COUNT_QUERY = gql`
  query productCount($attributeId: Int!) {
    product(attributeIds: [$attributeId]) {
      data {
        id
      }
      count
    }
  }
`;

export const ATTRIBUTE_VENDOR_COUNT_QUERY = gql`
  query vendorCount($attributeId: Int) {
    vendor(attributeIds: [$attributeId]) {
      data {
        id
      }
      count
    }
  }
`;

export const ATTRIBUTE_COMPANY_COUNT_QUERY = gql`
  query attributeCompanyCountQuery(
    $attributeId: Int!
    $localizeInstalls: Boolean!
    $isDp: Boolean
    $isDu: Boolean
    $isGhq: Boolean
    $isGp: Boolean
    $isGu: Boolean
  ) {
    opportunityGeneratorSearch(
      filters: {
        productAttributes: { ids: [$attributeId] }
        isDp: $isDp
        isDu: $isDu
        isGhq: $isGhq
        isGp: $isGp
        isGu: $isGu
      }
      localizeInstalls: $localizeInstalls
    ) {
      data {
        name
        hgId
        url
        countryName
        revenueRange {
          min
          max
          band
        }
      }
      count
    }
  }
`;

export const ATTRIBUTE_INSTALL_COUNT_QUERY = gql`
  query attributeInstallCount($attributeId: Int!, $localizeInstalls: Boolean!) {
    productCatalogInstallsCount(
      attributeIds: [$attributeId]
      localizeInstalls: $localizeInstalls
    ) {
      count
    }
  }
`;

export const ATTRIBUTE_PRODUCT_TABLE_QUERY = gql`
  query getProductsByAttributeIds($attributeId: Int!) {
    product(attributeIds: [$attributeId]) {
      data {
        id
        name
      }
      count
    }
  }
`;
